import type {ListServicesSearch} from "./-types";

import {listServicesQueryOptions} from "@project/application/engineering/services";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {ServicesPage} from "./-page/services.page";
import {ServicesPending} from "./-page/services.pending";
import {listServicesSearchSchema} from "./-types";

export type {ListServicesSearch} from "./-types";

export const Route = createFileRoute("/_app/engineering/services/")({
  component: ServicesPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") {
      return queryClient.ensureQueryData(listServicesQueryOptions(deps as ListServicesSearch));
    }

    void queryClient.prefetchQuery(listServicesQueryOptions(deps as ListServicesSearch));

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: ServicesPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => listServicesSearchSchema.parse(search),
});
